import API from "../api/axios";

// ─── Dashboard Stats ─────────────────────────
export const getDashboardStats = () => {
   return API.get("/dashboard-stats");
};

// ─── Followup Summary ────────────────────────
export const getFollowupsSummary = () => {
   return API.get("/followups-summary");
};

// ─── Revenue (with optional date filter) ─────
export const getRevenue = (startDate, endDate) => {
   let url = "/dashboard/revenue";
   if (startDate && endDate) {
      url += `?startDate=${startDate}&endDate=${endDate}`;
   }
   return API.get(url);
};

// ─── Conversion Stats ────────────────────────
export const getConversionStats = () => {
   return API.get("/dashboard/conversion");
};

// ─── Pending Users Count (Admin Only) ────────
export const getPendingUsersCount = () => {
   return API.get("/users/pending-count");
};

// ─── Project Stats ───────────────────────────
export const getProjectStats = () => {
   return API.get("/dashboard/project-stats");
};

// ─── Unassigned Leads Count ──────────────────
export const getUnassignedCount = () => {
   return API.get("/dashboard/unassigned-count");
};

// ─── Report Summary (daily/weekly/monthly) ───
export const getReportSummary = (type) => {
   return API.get(`/dashboard/report-summary?type=${type}`);
};

// ─── Sales Stats ─────────────────────────────
export const getSalesStats = () => {
   return API.get("/sales-stats");
};

// ─── License Stats (Admin Only) ──────────────
export const getLicenseStats = () => {
   return API.get("/license-stats");
};

export const getFunnelStats = async () => {
   try {

      const res = await API.get(
         "/dashboard/funnel-stats"
      );

      return res;

   } catch (err) {

      console.error(
         "Get Funnel Stats Error:",
         err.response?.data || err.message
      );

      throw err;
   }
};